import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/sponsorshipMedia'
export const namespace = 'sponsorshipMedia'
export const clientRoute = '/event/sponsorshipMedia'
export const dependencies = ['sponsorshipTitle']
export const params = {
  include: 'sponsorshipTitle'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'sortOrder'
const subtitleColumn = 'imageUrl'
const infoColumns = []
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
